import {Injectable} from '@angular/core';
import {ComponentBase} from '../../component-base';
import {Select3dService} from '../../services/select-3d.service';
import {ObjectCheckerService} from '../../services/object-checker.service';
import {StairsDimensionService} from '../../services/stairs-dimension.service';

@Injectable()
export class StairsDimensionsComponent extends ComponentBase {

  constructor(
    private selectSrvc: Select3dService,
    private objectChkr: ObjectCheckerService,
    private stairDimensionsSrvc: StairsDimensionService
  ) {
    super();
    selectSrvc.objectSelect.subscribe(this.onSelect);
  }

  private onSelect = (object) => {
    if (object && this.objectChkr.isStairs(object)) {
      this.stairDimensionsSrvc.update(object);
    } else {
      this.stairDimensionsSrvc.hide();
    }
  };

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/stairs-dimensions.component.ts